<template>
  <label v-if="!full" class="flow-group" :class="[{'flow-group--selected': checked}, `flow-group--${color}`]">
    <input v-model="checked" type="checkbox" class="flow-group__checkbox" @change="$emit('select-item', checked)" />
    <span class="flow-group__name" v-tooltip="group.name">{{ group.name }}</span>
  </label>

  <label
    v-else
    class="flow-group flow-group--full"
    :class="[{'flow-group--selected': checked}, `flow-group--${color}`]"
  >
    <div class="flow-group__header">
      <span class="flow-group__name" v-tooltip="group.name">{{ group.name }}</span>
      <input v-model="checked" type="checkbox" class="flow-group__checkbox" @change="$emit('select-item', checked)" />
    </div>

    <div class="flow-group__feature">Number of contacts</div>
    <div class="flow-group__info">{{ group.contacts_count }}</div>
  </label>
</template>

<script>
import dateFormatter from '../../mixins/dateFormatter';

export default {
  name: 'flow-group',
  mixins: [dateFormatter],
  data() {
    return {
      checked: false,
    };
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
      default: 'green',
    },
    full: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    selected: {
      immediate: true,
      handler(val) {
        if (val !== this.checked) {
          this.checked = val;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';

.flow-group {
  height: 56px;
  background: $white-color;
  color: $dove-grey-color;
  padding: 0 16px;
  display: flex;
  align-items: center;
  border: 1px solid $platinum-color;
  border-radius: 4px;
  gap: 16px;
  flex-grow: 1;
  min-width: 32%;
  margin: 0;
  font-size: 16px;
  cursor: pointer;

  &--selected.flow-group--green {
    border-color: $half-baked-color;
  }
  &--green &__checkbox {
    &:checked {
      background-color: $half-baked-color;
      border: 2px solid $half-baked-color;
    }
  }

  &__checkbox {
    -webkit-appearance: none;
    background-color: $white-color;
    border: 2px solid $dove-grey-color;
    padding: 8px;
    border-radius: 2px;
    display: inline-block;
    position: relative;

    &:checked:after {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f00c';
      font-size: 14px;
      position: absolute;
      top: 0px;
      left: 1px;
      color: $white-color;
    }
  }
  &__name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    user-select: none;
  }
  &__header {
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  &--full {
    height: 115px;
    padding: 16px;
    display: block;
    text-align: left;
    position: relative;
    justify-content: space-between;
  }
  &__feature {
    font-weight: 700;
  }
  &__info {
    margin-bottom: 5px;
    min-height: 25px;
  }
}
</style>
